import {css} from "@emotion/css";
import {rgba} from "polished";

import {designColors} from "~/ui";
import {getHoverColor} from "~/utils/colors";

export const styles = {
  primaryButton: css`
    &.MuiButton-root {
      &,
      &:hover,
      &:active {
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 69, 0.25);
      }
      &.Mui-focusVisible {
        box-shadow:
          0px 2px 0px 0px rgba(0, 0, 69, 0.25),
          inset 0 0 0 2px ${designColors.blue_3};
      }
      &.Mui-disabled {
        color: ${designColors.white};
        background-color: ${rgba(designColors.primary, 0.4)};

        box-shadow: 0px 2px 0px 0px rgba(0, 0, 69, 0.1);
      }
    }

    & .MuiLoadingButton-loadingIndicator {
      color: ${designColors.white};
    }

    & .MuiTouchRipple-root span {
      background-color: ${getHoverColor(designColors.primary, "lighter")};
      border-radius: 50%;

      opacity: 1 !important;
    }
  `,
};
